import {compose} from 'redux';
import {connect} from 'react-redux';
import {Field, reduxForm, reset, SubmissionError} from 'redux-form';
import {Button, Form, Message, Segment} from 'semantic-ui-react';
import {FormCheckbox, FormInput, FormSelect, FormTextArea, persian} from '../shared/forms';
import {mobile, password, required} from '../shared/forms/validations';
import {normalizeName} from '../shared/forms/normalizers';
import {registerUser} from '../../redux/actions/auth';

function RegisterForm(props) {
  const {handleSubmit, pristine, submitting, error} = props;
  const STUDENT_TYPE_OPTIONS = props.studentTypes.map(
    ({id, name}) => ({name, value: id, text: name})
  );
  return (
    <Segment>
      {/*form error*/}
      {(error && !pristine) && (
        <Message
          error
          header={error}
          className={'text-center'}
        />
      )}

      {/*form*/}
      <Form onSubmit={handleSubmit(submit.bind(null, props))}>
        <Form.Group widths='equal'>
          <Field
            required
            name='firstName'
            label='نام'
            component={FormInput}
            validate={[required, persian]}
            normalize={normalizeName}
          />
          <Field
            required
            name='lastName'
            label='نام خانوادگی'
            component={FormInput}
            validate={[required, persian]}
            normalize={normalizeName}
          />
        </Form.Group>
        <Form.Group widths='equal'>
          <Field
            required
            name='gender'
            label='جنسیت'
            component={FormSelect}
            options={GENDER_OPTIONS}
            validate={required}
          />
          <Field
            required
            name='telegramMobile'
            label='شماره تلفن اکانت تلگرام'
            placeholder='09121234567'
            component={FormInput}
            validate={[required, mobile]}
          />
        </Form.Group>
        <Form.Group widths='equal'>
          <Field
            required
            name='password'
            label='رمز عبور'
            type='password'
            component={FormInput}
            validate={[required, password]}
          />
          <Field
            required
            name='rePassword'
            label='تائید رمز عبور'
            type='password'
            component={FormInput}
            validate={required}
          />
        </Form.Group>
        <Field
          required
          name='type'
          label='داوطلب کدامیک از دوره‌های زیر هستید؟'
          component={FormSelect}
          options={STUDENT_TYPE_OPTIONS}
          validate={required}
        />
        <Field
          required
          name='eduStatus'
          label='وضعیت تحصیلی'
          component={FormSelect}
          options={EDUCATIONAL_STATUS_OPTIONS}
          validate={required}
        />
        <Field
          required
          name='tarhStatus'
          label='وضعیت طرح یا سربازی'
          component={FormSelect}
          options={TARH_STATUS_OPTIONS}
          validate={required}
        />
        <Field
          required
          name='prevExamsStatus'
          label='نتیجه امتحانات رزیدنتی قبلی'
          component={FormSelect}
          options={PREVIOUS_EXAMS_STATUS_OPTIONS}
          validate={required}
        />
        <Field
          required
          name='contactMethod'
          label='برای اولین بار از چه طریقی با گروه مد مشاور آشنا شده‌اید؟'
          component={FormSelect}
          options={CONTACT_METHOD_OPTIONS}
          validate={required}
        />
        <Field
          name='description'
          label='توضیحات'
          placeholder='اگر شرایط خاص دیگری دارید توضیح دهید'
          component={FormTextArea}
        />
        <Field
          required
          name='termsAndConditions'
          label={<label>
            فایل‌های
            &nbsp;
            <a
              href={process.env.PUBLIC_URL + '/documents/برنامه آزمون های دستیاری 1404.pdf'}
              rel='noopener noreferrer'
              target='_blank'
            >
              "برنامه آزمون های دستیاری 1404"
            </a>
            &nbsp;
            و
            &nbsp;
            <a
              href={process.env.PUBLIC_URL + '/documents/راهنمای ثبت نام مشاوره خصوصی.pdf'}
              rel='noopener noreferrer'
              target='_blank'
            >
              "راهنمای ثبت نام مشاوره خصوصی"
            </a>
            &nbsp;
            را مطالعه کرده‌ام و شرایط و قوانین ذکر شده را می‌پذیرم.
          </label>}
          component={FormCheckbox}
          validate={required}
        >
        </Field>
        <Button
          type='submit'
          disabled={pristine || submitting}
          content='تایید'
        />
      </Form>
    </Segment>
  );
}

const GENDER_OPTIONS = [
  {name: 'مرد', text: 'مرد', value: 'M'},
  {name: 'زن', text: 'زن', value: 'F'}
];

const EDUCATIONAL_STATUS_OPTIONS = [
  'استاژر هستم.',
  'اوایل اینترنی هستم.',
  'اواخر اینترنی هستم.',
  'بخش های اینترنی تمام شده و تا امتحان آف هستم.',
  'فارغ التحصیل شده ام.'
].map(text => ({name: text, value: text, text}));

const TARH_STATUS_OPTIONS = [
  'در حال تحصیل هستم و به صورت استریت امتحان خواهم داد.',
  'در حال گذراندن طرح یا سربازی هستم.',
  'طرحم تمام شده و شاغل نیستم و وقتم آزاد هست.',
  'طرح یا سربازی ام تمام شده و در حال حاضر مشغول به کار هستم.'
].map(text => ({name: text, value: text, text}));

const PREVIOUS_EXAMS_STATUS_OPTIONS = [
  'قبلا امتحان نداده ام.',
  'در امتحانات قبلی تلاش کافی نداشتم و نتیجه خوبی نگرفتم.',
  'در امتحانات قبلی علی رغم مطالعه کافی نتیجه خوبی نگرفتم.',
  'در امتحانات قبلی نتیجه نسبتا خوبی گرفتم، ولی ترجیح دادم مجددا برای رشته بهتر امتحان دهم.'
].map(text => ({name: text, value: text, text}));

const CONTACT_METHOD_OPTIONS = [
  'از طریق تلگرام',
  'از طریق اینستاگرام',
  'سایر موارد ...'
].map(text => ({name: text, value: text, text}));


function validate(values) {
  const errors = {};
  if (values.password !== values.rePassword) errors.rePassword = 'رمزهای عبور غیر یکسان هستند.';
  return errors;
}

async function submit(props, values) {
  const {rePassword, termsAndConditions, ...validatedValues} = values;
  try {
    await props.registerUser(validatedValues);
  } catch (error) {
    throw new SubmissionError(error.data);
  }
}

function mapStateToProps(state, {mobile, authKey}) {
  return {initialValues: {mobile, authKey}};
}

export default compose(
  connect(mapStateToProps, {registerUser, reset}),
  reduxForm({form: 'register', validate})
)(RegisterForm);
